<template>
  <div class="common-header">
      <div class="common-header-back rac font14">
        <div @click="goBack">返回</div>
        <div>
          <router-link tag="span" :to="'/noticy'" class="iconfont icon-xiaoxi"></router-link>
          <span class="dot"></span>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  },
};
</script>

<style lang="less" scoped>
.common-header {
    position: fixed;
    width: 100%;
    height: 40px;
    .common-header-back {
      box-sizing: border-box;
      padding: 0 15px;
      width: 100%;
      height: 40px;
      background: #246FDD;
      color: white;
      .icon-shezhi-copy {
        margin-right: 4px;
      }
      & > div:last-child {
        position: relative;
        .dot {
          position: absolute;
          border-radius: 50%;
          width: 5px;
          height: 5px;
          top: 0;
          right: -6px;
          background: white;
        }
      }
    }
}
</style>